jQuery(function($){
    	$('.marquee').slick({
    		slidesToShow: 4,
    		slidesToScroll: 1,
    		autoplay: true,
            autoplaySpeed: 0,
            speed: 2000,
            variableWidth: true,
            pauseOnHover: false,
            cssEase: 'linear',
    		arrows: false,
    		dots: false,
    		responsive: [
    		{
    		  breakpoint: 1024,
    		  settings: {
    			autoplay: true,
    			slidesToShow: 2,
    			slidesToScroll: 1
    		  }
    		},
    		{
    		  breakpoint: 600,
    		  settings: {
    			autoplay: true,
    			slidesToShow: 1,
    			slidesToScroll: 1
    		  }
    		},
    		{
    		  breakpoint: 480,
    		  settings: {
    			autoplay: true,
    			slidesToShow: 1,
    			slidesToScroll: 1
    		  }
    		}
    		
    	  ]
    		
    	});
    });
// jQuery(function($){
//     	$('body.template--product .product-media--container').slick({
//     		slidesToShow: 1,
//     		slidesToScroll: 1,
//     		autoplay: false,
//             autoplaySpeed: 0,
//             speed: 2000,
//             pauseOnHover: false,
//     		arrows: false,
//     		dots: true,
//     		responsive: [
//     		{
//     		  breakpoint: 1024,
//     		  settings: {
//     			autoplay: true,
//     			slidesToShow: 1,
//     			slidesToScroll: 1
//     		  }
//     		},
//     		{
//     		  breakpoint: 600,
//     		  settings: {
//     			autoplay: true,
//     			slidesToShow: 1,
//     			slidesToScroll: 1
//     		  }
//     		},
//     		{
//     		  breakpoint: 480,
//     		  settings: {
//     			autoplay: true,
//     			slidesToShow: 1,
//     			slidesToScroll: 1
//     		  }
//     		}
    		
//     	  ]
    		
//     	});
//     });
jQuery(function($){
  // Function to apply translations based on the "lang" attribute
    function translateContent() {
      var lang = $('html').attr('lang'); // Assuming the lang attribute is on the <html> tag
      if (lang === 'fr') {
        //alert('French...');
        
        $('.fntitle').text("Infolettre");
        $('.ftxt').text("Rejoignez la communauté et recevez des mises à jour sur les nouveautés et les promotions.");
        $('.klaviyo-form-UEqkyV').hide();
        $('.klaviyo-form-Xey4q2').show();
      } else {
        $('.klaviyo-form-Xey4q2').hide();
        $('klaviyo-form-UEqkyV').show();
      }
    }

    // Call the translation function on page load
    translateContent();
  
});

/* Footer fade */
(function() {
  function initFooterFade() {
    const footer = document.querySelector('.footer--root');
    if (!footer) {
      setTimeout(initFooterFade, 1000);
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            footer.classList.add('footer--visible');
          } else {
            footer.classList.remove('footer--visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(footer);
  }

  window.addEventListener('load', initFooterFade);
})();


(function() {
  function initAnnouncementBar() {
    const bar = document.querySelector('.announcement--root');
    if (!bar) {
      console.warn('Announcement bar not found');
      return;
    }

    // Start hidden
    bar.classList.remove('announcement--visible');

    // Reveal animation after a short delay
    setTimeout(() => {
      bar.classList.add('announcement--visible');
    }, 20); // delay for smooth entry
  }

  window.addEventListener('load', initAnnouncementBar);
})();
